interface RadiusFilterProps {
  value: number;
  onChange: (km: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

const PRESETS = [10, 25, 50, 100, 200];

export function RadiusFilter({ value, onChange, min = 5, max = 300, step = 5, className = '' }: RadiusFilterProps) {
  return (
    <div className={`space-y-3 ${className}`}>
      {/* Slider */}
      <div className='flex items-center gap-3'>
        <input
          type='range'
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={e => onChange(Number(e.target.value))}
          className='flex-1 h-2 bg-slate-200 rounded-full appearance-none cursor-pointer accent-blue-600'
        />
        <span className='text-sm font-semibold text-slate-700 w-16 text-right'>{value} km</span>
      </div>

      {/* Préréglages rapides */}
      <div className='flex flex-wrap gap-1.5'>
        {PRESETS.map(km => (
          <button
            key={km}
            type='button'
            onClick={() => onChange(km)}
            className={`px-2.5 py-1 rounded-lg text-xs font-semibold transition-colors ${
              value === km ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
            }`}
          >
            {km} km
          </button>
        ))}
      </div>
    </div>
  );
}
